import { atom } from "jotai";

import { SignatureFlowStep } from "../types/signature-flow-step.enum";
import type { ISignaturePositionWithPageIndex } from "../types/signature-position.interface";

export interface ISignatureDocumentFlowState {
  step: SignatureFlowStep;
  documentId?: number;
  fileUrl?: string;
  signatures: ISignaturePositionWithPageIndex[];
}

export const DEFAULT_SIGNATURE_DOCUMENT_FLOW_STATE: ISignatureDocumentFlowState = {
  step: SignatureFlowStep.View,
  signatures: [],
};

export const signatureDocumentFlowAtom = atom<ISignatureDocumentFlowState>(DEFAULT_SIGNATURE_DOCUMENT_FLOW_STATE);
